<template>
  <div>
      <div class="title"> Orbital Mechanics </div>
      <div class="date"> December 15th, 2018 </div>

      <div class="content">
        
		<canvas style="width: 100%; height: 500px; border: 1px solid gainsboro" id="canvas"></canvas>
		<div style="display: table; margin: 0px auto;">
			<div class="quote" style="display: inline-block; margin: 0px auto;">Press space to start animation. Hold space to spawn new random satellites.</div>😉	
		</div>
		<p>&emsp;So finals are over and I have nothing to do. In one of my classes, we learned about orbital mechanics and some of the physics behind it. I decided to simulate this programmatically because I have nothing better to do. The larger red dot following a circular orbit is actually the ISS. This animation is to scale (apart from the size of the satellites), but sped up 1000 times. Of course, in reality the satellites would interact with each other, but that is not the point here. I was surprised how relatively simple it was implement this, the most confusing part was making sure all of the units were correct, as the dimensions and velocities are based upon the actual measurements of the Earth.</p>
		<p>
			&emsp;There are two equations which govern these mechanics.
		</p>
		<p>$$\frac{d^2y}{dt^2} = \frac{MG}{r^3}y \quad \text{and} \quad
             \frac{d^2x}{dt^2} = \frac{MG}{r^3}x, \; \text{where} \; r = \sqrt{x^2+y^2}$$</p>
		<p>&emsp;This is a nonlinear system of differential equations, with no simple analytical solution as far as I know. In class, we simulated these equations using finite difference methods in excel. Programmatically, I used Euler's method: first calculate the `a_x` and `a_y` accelerations by plugging in values into the above equations, then adding `a_x\Delta t` and `a_y\Delta t` to `v_x` and `v_y` respectively. Lastly, calculate the new `x` and `y` positions by adding `v_x\Delta t` and `v_y\Delta t` to the current positions.</p>
		<p>&emsp;I am one step closer to being able to launch a rocket into space. 🧙‍🤓😏</p>
	
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'OrbitalMechanics',
  mounted: () => {
      do_js();
      window.MathJax.typesetPromise();
  }
}

function do_js() {
var canvas = document.querySelector("#canvas");
var cx = canvas.getContext("2d");

class Satellite {
	constructor(x, y, vx, vy, color) {
		this.x = x;
		this.y = y;
		this.vx = vx;
		this.vy = vy;
		this.color = color;
	}

	move(time) {
		let r = (x, y) => Math.pow(x, 2) + Math.pow(y, 2);
		// Acceleration = G * m * (x^2 + y^2) ^ (-1.5)
		let sec = time;
		let omega = -1 * this.G * this.M * Math.pow(r(this.x, this.y), -1.5);
		this.vx += sec * omega * this.x;
		this.vy += sec * omega * this.y;
		this.x += sec * this.vx;
		this.y += sec * this.vy;
		// console.log(this.x + " " + this.y);
	}
}
Satellite.prototype.M = 5.9742 * Math.pow(10, 24); // kg
Satellite.prototype.G = 6.673 * Math.pow(10, -11); // m^3 / kg / s^2
const radiusOfEarth = 6378100; // meters
const altitudeISS = 408000; // meters
const speedISS =  7610; // meters per sec

// window.addEventListener("resize", onResize);
function onResize() {
	let dpi = window.devicePixelRatio;
	canvas.width = getComputedStyle(canvas).getPropertyValue("width").slice(0, -2) * dpi;
	canvas.height = getComputedStyle(canvas).getPropertyValue("height").slice(0, -2) * dpi;
	console.log(canvas.width + " " + canvas.height);
}
onResize();
			
var center = [canvas.width / 2, canvas.height / 2];
var satellites = [new Satellite(radiusOfEarth + altitudeISS, 0, 0, speedISS, "red")];
for (let i = 0; i < 25; i++) {
	satellites.push(new Satellite(radiusOfEarth + altitudeISS * (Math.random() + 1), 0, 0, speedISS * (Math.random() * 0.3 + 1),
		randomColor()));
}
var imgEarth = document.createElement("img");
imgEarth.src = "static/earth.png";
imgEarth.addEventListener("load", () => {
	drawObjects();
});

function randomColor() {
	let r = () => {
		let rand = Math.floor(Math.random() * 256).toString(16);
		if (rand.length == 1) rand = "0" + rand;
		return rand;
	}
	return "#" + r() + r() + r();
}

function drawCircle(x, y, radius) {
	cx.beginPath();
	cx.arc(x, y, radius, 0, 7);
	cx.fill();
}
			
function drawObjects() {
	cx.clearRect(0, 0, canvas.width, canvas.height);
	let len = canvas.height * .15; // pixel diameter of earth image
	cx.drawImage(imgEarth, (canvas.width - len) / 2, (canvas.height - len) / 2, len, len);
	let ppm = len / radiusOfEarth; // pixels per meter, convert units

	for (let i = 0; i < satellites.length; i++) {
		let s = satellites[i];
		cx.fillStyle = s.color;
		drawCircle(ppm * s.x + center[0], ppm * s.y + center[1], (i == 0) ? 5 : 3);
	}
}

var inOrbit = false;
function orbit() {
	inOrbit = true;
	function nextFrame(time, lastTime) {
	if (lastTime == null)
		lastTime = time;
		for (let satellite of satellites)
			satellite.move(time - lastTime, [canvas.width / 2, canvas.height / 2]);
		drawObjects();
		requestAnimationFrame(newTime => nextFrame(newTime, time));
	}
requestAnimationFrame(nextFrame);
}

window.addEventListener("keydown", e => {
	if (e.key == " ") {
		satellites.push(new Satellite(radiusOfEarth + altitudeISS * (Math.random() + 1), 0, 0, speedISS * (Math.random() * 0.3 + 1),
			randomColor()));
		if (!inOrbit) orbit();
	}
	e.preventDefault();
});
}

</script>

<style scoped>

</style>
